var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"video-player",rawName:"v-video-player:myVideoPlayer",value:(_vm.specs),expression:"specs",arg:"myVideoPlayer"}],staticClass:"vjs-big-play-centered"})}
var staticRenderFns = []

export { render, staticRenderFns }